import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const TransfersIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M17.707 2.293a1 1 0 1 0-1.414 1.414L18.586 6H9a1 1 0 0 0 0 2h9.586l-2.293 2.293a1 1 0 0 0 1.414 1.414l4-4a1 1 0 0 0 0-1.414l-4-4Zm-10 10a1 1 0 0 1 0 1.414L5.414 16H15a1 1 0 1 1 0 2H5.414l2.293 2.293a1 1 0 1 1-1.414 1.414l-4-4a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 0Z" />
    </Icon>
  )
);
export default TransfersIcon;
